const { getElement } = window.BAO.Utils

export class ProductForm extends window.BAO.CustomElement() {
  constructor () {
    super()

    this.sections = this.inPushCart
      ? window.BAO.sectionRenderer.pushCartSections
      : this.onCartPage
        ? window.BAO.sectionRenderer.cartSections
        : []
  }

  setupListeners () {
    super.setupListeners()

    this.listeners.add(this.form, 'submit', this.onSubmitHandler.bind(this))
  }

  checkValidity () {
    super.checkValidity()

    if (!this.form) {
      this.throwError(`needs to be wrapped around a product's <form> element`)
    }
  }

  async onSubmitHandler (e) {
    e.preventDefault()

    await this.addToCart()
  }

  async addToCart () {
    return window.BAO.Cart.addItemFromForm(this.form, {
      sections: this.mappedSections,
    })
  }

  get mappedSections () {
    return this.sections.map(s => s.section)
  }

  get pushCart () {
    return getElement('push-cart')
  }

  get inPushCart () {
    return this.pushCart != null
  }

  get cart () {
    return getElement('cart-items')
  }

  get onCartPage () {
    return this.cart != null
  }

  /**
   * @returns {HTMLFormElement|null}
   */
  get form () {
    return this.querySelector('form')
  }
}

customElements.define('product-form', ProductForm)
